import { toast } from 'react-toastify';

const DURATION = 2000;

const options = {
    autoClose: DURATION,
    hideProgressBar: false,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    draggable: false,
    closeOnClick: true,
};

export const showSuccess = (msg) => {
    const id = toast.success(msg, options);
    setTimeout(() => toast.dismiss(id), DURATION);
};

export const showError = (msg) => {
    const id = toast.error(msg, options);
    setTimeout(() => toast.dismiss(id), DURATION);
};

export const showWarn = (msg) => {
    const id = toast.warn(msg, options);
    setTimeout(() => toast.dismiss(id), DURATION);
};



